import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const HofdienstProtectedRoute = ({ children, user }) => {
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      setLoading(true);
      setAuthorized(false);

      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const userDocRefById = doc(db, "users", user.uid);
        const userDocRefByEmail = doc(db, "users", user.email);

        const [byIdSnap, byEmailSnap] = await Promise.all([
          getDoc(userDocRefById),
          getDoc(userDocRefByEmail),
        ]);

        const userData = byIdSnap.exists() ? byIdSnap.data() : byEmailSnap.exists() ? byEmailSnap.data() : null;

        if (!userData) {
          setAuthorized(false);
        } else {
          const allowed = new Set(["admin", "moderator", "hofdienst"]);
          const role = userData.role;
          const roles = userData.roles;

          let isAllowed = false;

          if (typeof role === "string") {
            isAllowed = allowed.has(role.toLowerCase());
          } else if (Array.isArray(roles)) {
            isAllowed = roles.some(r => typeof r === "string" && allowed.has(r.toLowerCase()));
          }

          setAuthorized(isAllowed);
        }
      } catch (err) {
        console.error("HofdienstProtectedRoute check failed:", err);
        setAuthorized(false);
      } finally {
        setLoading(false);
      }
    };

    void checkAccess();
  }, [user]);

  if (loading) return <div>Loading...</div>;

  if (!user) return <Navigate to="/" replace />;

  if (!authorized) return <Navigate to="/home" replace />;

  return children;
};
